import React, { useState } from 'react';
import { object, func, string } from 'prop-types';
import { get, isEmpty, toNumber, isNumber } from 'lodash';
import { FlexContainer, FormInput, Text, Icon, Button, DrawerHeader, Row, Column } from '../../common';
import MODIFY_PRODUCT from '../../graphql/modifyProduct';
import ConfirmFooterButtons from '../../common/ConfirmFooterButtons/ConfirmFooterButton';
import styled from 'styled-components';
import { withApollo } from 'react-apollo';

const ModifyProduct = ({
    session,
    idOrder,
    item,
    client,
    onClose
}) => {
    const Quantity = styled.div`
        width: 47px;
        font-weight: bold;
        height: 34px;
        border: 1px solid #E8E8E8;
        border-radius: 4px;
        background-color: #E8E8E8;
        text-align: center;
        margin-right: 3px;
        line-height: 30px;
    `;
    const initSellingPrice = get(item, 'unit') === 'uni'
        ? get(item, 'sellingPrice')
        : (get(item, 'sellingPrice') / toNumber(get(item, 'unitMultiplier')));
    const [loading, setLoading] = useState(false);
    const [comment, setComment] = useState(false);
    const [quantity, setQuantity] = useState(toNumber(get(item, 'quantity')));
    const [sellingPrice, setSellingPrice] = useState(initSellingPrice);
    const [originalSellingPrice] = useState(initSellingPrice);
    const [originalQuantity] = useState(toNumber(get(item, 'quantity')));

    const onChangeComments = (value) => {
        setComment(value);
    };

    const onChangeQuantity = () => {
        quantity > 1 && setQuantity(quantity - 1);
    };

    const onChangeQuantityMinus = () => {
        quantity < originalQuantity && setQuantity(quantity + 1);
    };

    const onChangeSellingPrice = (value) => {
        toNumber(value) <= originalSellingPrice && setSellingPrice(value);
    };

    const validateDisabled = () => {
        const notChanged = originalSellingPrice === sellingPrice && originalQuantity === quantity;
        return !(!isEmpty(comment) && !notChanged) || !(sellingPrice > 0);
    };

    const getQuantity = () => {
        return get(item, 'unit') === 'uni'
            ? quantity
            : (quantity * toNumber(get(item, 'unitMultiplier'))).toFixed(3);
    };

    return (
        <FlexContainer direction='column' flex={1}>
            <DrawerHeader title='Editar Producto' onClose={onClose} />
            <FlexContainer style={{ marginBottom: 10 }}>
                <Column style={{ lineHeight: '30px' }}>
                    <Text size={13} text='Cantidad' />
                </Column>
                <Row flex={2} justify='flex-end'>
                    <Button
                        right={3}
                        width={45}
                        backgroundColor='#616161'
                        onClick={() => onChangeQuantity(quantity)}
                        style={{ border: '1px solid #616161' }}
                    >
                        <Icon name='minus' size='12' color='#ffffff' />
                    </Button>
                    <Quantity>{getQuantity()}</Quantity>
                    <Button
                        width={45}
                        backgroundColor={quantity < originalQuantity ? '#616161' : '#dddddd'}
                        onClick={() => onChangeQuantityMinus()}
                        style={{
                            border: `1px solid ${quantity < originalQuantity ? '#616161' : '#dddddd'}`,
                            pointerEvents: `${quantity < originalQuantity ? '' : 'none'}`
                        }}
                    >
                        <Icon name='plus' size='12' color='#ffffff' />
                    </Button>
                </Row>
            </FlexContainer>
            <FormInput
                label='Precio'
                value={sellingPrice === '' ? '' : parseInt(sellingPrice)}
                onChange={event => onChangeSellingPrice(get(event, 'target.value', null))}
            />
            <FormInput
                label='Comentario'
                textArea
                onChange={event => onChangeComments(get(event, 'target.value', null))}
            />
            <ConfirmFooterButtons
                confirmDisabled={validateDisabled()}
                onConfirm={
                    async () => {
                        if (sellingPrice > 0) {
                            setLoading(true);
                            const { data } = await client.mutate({
                                mutation: MODIFY_PRODUCT,
                                variables: {
                                    orderId: idOrder,
                                    ean: get(item, 'ean'),
                                    comment,
                                    sellingPrice: get(item, 'unit') === 'uni'
                                        ? toNumber(sellingPrice)
                                        : parseInt(sellingPrice * get(item, 'unitMultiplier')),
                                    quantity: toNumber(quantity),
                                    email: get(session, 'email')
                                },
                                refetchQueries: ['getOrderItems', 'getPickingInfoBy']
                            });
                            setLoading(false);
                            onClose();
                        };
                    }
                }
                onCancel={onClose}
                loading={loading} />
        </FlexContainer>
    );
};

ModifyProduct.propTypes = {
    idOrder: string,
    item: object,
    onClose: func,
    client: object,
    session: object
};

export default withApollo(ModifyProduct);
